export default "__VITE_ASSET__BjXm8BTQ__"